// import React, { useEffect } from "react";

// const Chatbot = () => {
//   useEffect(() => {
//     // Dynamically load the Dialogflow script
//     const script = document.createElement("script");
//     script.src =
//       "https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js";
//     script.async = true;
//     document.body.appendChild(script);

//     // Dynamically load the Dialogflow stylesheet
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href =
//       "https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css";
//     document.head.appendChild(link);

//     // Cleanup script and link on component unmount
//     return () => {
//       document.body.removeChild(script);
//       document.head.removeChild(link);
//     };
//   }, []);

//   return (
//     <df-messenger
//       location="asia-south1"
//       project-id="sab-multilanguages"
//       agent-id="7122f13a-35a6-4f81-8dca-e8228da8d0df"
//       language-code="en"
//       max-query-length="-1"
//       style={{
//         zIndex: 999,
//         position: "fixed",
//         bottom: "16px",
//         right: "16px",
//         "--df-messenger-font-color": "#000",
//         "--df-messenger-font-family": "Google Sans",
//         "--df-messenger-chat-background": "#f3f6fc",
//         "--df-messenger-message-user-background": "#d3e3fd",
//         "--df-messenger-message-bot-background": "#fff",
//       }}
//     >
//       <df-messenger-chat-bubble chat-title="SAB Campus" />
//     </df-messenger>
//   );
// };

// export default Chatbot;

import { useEffect } from "react";

const TawkToChat = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://embed.tawk.to/67b2f1157de526190ea05d71/1ik9frf20";
        script.async = true;
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        document.body.appendChild(script);

        script.onload = () => {
            if (window.Tawk_API) {
                window.Tawk_API.hideWidget();
                setTimeout(() => {
                    window.Tawk_API.setAttributes({
                        'prechatForm': true
                    }, function(error) {
                        if (error) console.error('Tawk.to Pre-Chat Form Error:', error);
                    });
                    window.Tawk_API.showWidget();
                }, 1000);
            }
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null;
};

export default TawkToChat;